import screen1 from '../../assets/images/screens/1.jpg';
import screen10 from '../../assets/images/screens/10.jpg';
import screen11 from '../../assets/images/screens/11.jpg';
import screen12 from '../../assets/images/screens/12.jpg';
import screen13 from '../../assets/images/screens/13.jpg';
import screen14 from '../../assets/images/screens/14.jpg';
import screen15 from '../../assets/images/screens/15.jpg';
import screen16 from '../../assets/images/screens/16.jpg';
import screen17 from '../../assets/images/screens/17.jpg';
import screen18 from '../../assets/images/screens/18.jpg';
import screen19 from '../../assets/images/screens/19.jpg';
import screen2 from '../../assets/images/screens/2.jpg';
import screen20 from '../../assets/images/screens/20.jpg';
import screen21 from '../../assets/images/screens/21.jpg';
import screen22 from '../../assets/images/screens/22.jpg';
import screen3 from '../../assets/images/screens/3.jpg';
import screen4 from '../../assets/images/screens/4.jpg';
import screen5 from '../../assets/images/screens/5.jpg';
import screen6 from '../../assets/images/screens/6.jpg';
import screen7 from '../../assets/images/screens/7.jpg';
import screen8 from '../../assets/images/screens/8.jpg';
import screen9 from '../../assets/images/screens/9.jpg';
import screen23 from '../../assets/images/screens/23.jpg';

export const imageSources = [
	screen1,
	screen2,
	screen3,
	screen4,
	screen5,
	screen6,
	screen7,
	screen8,
	screen9,
	screen10,
	screen11,
	screen12,
	screen13,
	screen14,
	screen15,
	screen16,
	screen17,
	screen18,
	screen19,
	screen20,
	screen21,
	screen22,
	screen23,
];

export const screenData = [
	// 1. Address Search (default on page load)
	{
		step_name: 'Address Search',
		last_screen_flag: '',
	},
	// 2. Address Search (Address input filled)
	{
		step_name: 'Address Search',
		last_screen_flag: '',
		no_refresh_flag: true,
		no_refresh_faq: true,
	},
	// 3. Customer Info (with customer info form - empty, residential tab selected)
	{
		step_name: 'Customer Info',
		last_screen_flag: '',
	},
	// 4. Customer Info (business tab selected)
	{
		step_name: 'Customer Info',
		address_type: 'business',
		last_screen_flag: '',
		no_refresh_faq: '',
	},
	// 5. Customer Info (First name filled, email yellow)
	{
		step_name: 'Customer Info',
		address_type: 'residential',
		last_screen_flag: '',
		no_refresh_flag: true,
	},
	// 6. Internet plans (Default 500 Mbps)
	{
		step_name: 'Internet Plans',
		last_screen_flag: '',
	},
	// 7. Internet plans (Selected: 1G)
	{
		step_name: 'Internet Plans',
		last_screen_flag: '',
		no_refresh_flag: true,
	},
	// 8. Phone plans (Default: No phone)
	{
		step_name: 'Phone Plans',
		last_screen_flag: '',
	},
	// 9. Phone plans (Selected: Digital voice - $20 )
	{
		step_name: 'Phone Plans',
		last_screen_flag: '',
		no_refresh_faq: true,
		no_refresh_flag: true,
	},
	// 10. Phone Configuration
	{
		step_name: 'Phone Configuration',
		last_screen_flag: '',
	},
	// 11. Schedule Install - date
	{
		step_name: 'Schedule Install',
		last_screen_flag: '',
	},
	// 12. Schedule Install - no refresh
	{
		step_name: 'Schedule Install',
		no_refresh_flag: true,
		no_refresh_faq: true,
	},
	// 13. Schedule Install - no refresh
	{
		step_name: 'Schedule Install',
		last_screen_flag: '',
		no_refresh_flag: true,
		no_refresh_faq: true,
	},
	// 14. Billing
	{
		step_name: 'Billing',
		last_screen_flag: '',
	},
	// 15. Billing - Paperless billing
	{
		step_name: 'Billing',
		last_screen_flag: '',
		no_refresh_faq: true,
	},
	// 16. Review and Verification  - no change
	{
		step_name: 'Review and Verification',
		last_screen_flag: '',
	},
	// 17. Review and Verification - no change
	{
		step_name: 'Review and Verification',
		last_screen_flag: '',
		no_refresh_flag: true,
		no_refresh_faq: true,
	},
	// 18. Review and Verification - no change
	{
		step_name: 'Review and Verification',
		last_screen_flag: '',
		no_refresh_faq: true,
		// no_refresh_flag: true,
	},
	// 19. Review and Verification - verification_mode = SMS text
	{
		step_name: 'Review and Verification',
		last_screen_flag: '',
		no_refresh_faq: true,
		// no_refresh_flag: true,
	},
	// 20. Review and Verification - verification_mode = SMS text
	{
		step_name: 'Review and Verification',
		last_screen_flag: '',
		no_refresh_flag: true,
		no_refresh_faq: true,
	},
	// 21. Review and Verification - verification_mode = email
	{
		step_name: 'Review and Verification',
		last_screen_flag: '',
		no_refresh_faq: true,
	  // no_refresh_flag: true,
	},
	{
		step_name: 'Review and Verification',
		last_screen_flag: '',
		no_refresh_faq: true,
		// no_refresh_flag: true,
	},
	// 22. Order submitted
	{
		step_name: 'Order submitted',
		last_screen_flag: 'Y',
		no_refresh_faq: true,
	  // no_refresh_flag: true,
	},
	
];
